import { create } from 'zustand';
import {
  applyTheme,
  loadThemeChoice,
  resolveTheme,
  type ResolvedTheme,
  type ThemeChoice,
} from '../lib/theme';

interface ThemeState {
  choice: ThemeChoice;
  resolved: ResolvedTheme;
  setChoice: (choice: ThemeChoice) => void;
  /** Re-resolves without changing the choice, for OS theme changes. */
  refresh: () => void;
}

const initialChoice = loadThemeChoice();

export const useTheme = create<ThemeState>((set, get) => ({
  choice: initialChoice,
  resolved: resolveTheme(initialChoice),

  setChoice(choice) {
     set({ choice, resolved: applyTheme(choice) });
  },

  refresh() {
     set({ resolved: applyTheme(get().choice) });
  },
}));
